import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Spin } from "antd";
import {
  LargeHeadingStyled,
  MediumLargeHeadingStyled,
} from "src/components/custom/texts/texts.styled";
import { getBoxStudentPage } from "../../../Api/content";
import { useLocale } from "../../../i18n/localeContext";

function PaymentReturn() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { locale } = useLocale();
  const [content, setContent] = useState<Record<string, string | undefined> | null>(null);
  const [hasError, setHasError] = useState(false);
  const processed = useRef(false);

  useEffect(() => {
    getBoxStudentPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        setContent(data);
      })
      .catch(() => setContent(null));
  }, [locale]);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const estado = searchParams.get("estado");
    const pagoId = searchParams.get("pagoId");

    if (estado === "aprobado" && pagoId && pagoId !== "0") {
      sessionStorage.removeItem("powerTranzOrderId");
      sessionStorage.removeItem("powerTranzSpiToken");
      navigate(`/last-receipt/${pagoId}/${null}`);
    } else if (estado === "rechazado") {
      sessionStorage.removeItem("powerTranzOrderId");
      navigate(
        `/payment-error/${encodeURIComponent("El-pago-fue-rechazado-por-la-entidad-bancaria")}`,
      );
    } else {
      setHasError(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "70vh",
        gap: "15px",
      }}
    >
      {!hasError && <Spin size="large" />}
      <LargeHeadingStyled>
        {!hasError
          ? content?.payment_return_processing_title || "Procesando pago"
          : content?.payment_return_error_title || "Error en el pago"}
      </LargeHeadingStyled>
      <MediumLargeHeadingStyled style={{ maxWidth: 750, textAlign: "center" }}>
        {!hasError
          ? content?.payment_return_verifying_message || "Verificando el estado de su pago..."
          : content?.payment_return_incomplete_message ||
            "No se pudo completar el pago. Por favor, contacte al departamento financiero."}
      </MediumLargeHeadingStyled>
    </div>
  );
}

export default PaymentReturn;
